import(/* webpackMode: "eager", webpackExports: ["keywords"] */ "/home/vantage/htdocs/www.vantagediesel.com/app/keywords.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/vantage/htdocs/www.vantagediesel.com/components/magicui/word-rotate.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/vantage/htdocs/www.vantagediesel.com/components/parallax.jsx");
;
import(/* webpackMode: "eager" */ "/home/vantage/htdocs/www.vantagediesel.com/node_modules/next/dist/client/image-component.js");
